/**
 * Cross-module session + navigation state.
 *
 *   sessionReady — true once the boot effect has checked the session
 *                  marker and (if present) called /insured/session. UI
 *                  shouldn't redirect away from /signin until this is true.
 *   dashView     — "dashboard" or null; non-null routes the user to
 *                  /dashboard. Set by sign-in success + sign-out resets.
 *   bound        — true once a policy is bound (post-pay confirmation UI).
 */
class SessionStore {
  #listeners = new Set();

  #sessionReady = false;
  #dashView = null;
  #bound = false;

  get sessionReady() { return this.#sessionReady; }
  set sessionReady(v) { this.#sessionReady = !!v; this.#notify(); }

  get dashView() { return this.#dashView; }
  set dashView(v) { this.#dashView = v; this.#notify(); }

  get bound() { return this.#bound; }
  set bound(v) { this.#bound = !!v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  /**
   * Reset everything except `sessionReady`. The boot check already ran,
   * so even after sign-out the app knows current auth state — flipping
   * `sessionReady` back to false would re-trigger FlowLayout's loading
   * overlay forever (the boot effect only runs once per mount).
   */
  clear() {
    this.#dashView = null;
    this.#bound = false;
    this.#notify();
  }
}

const sessionStore = new SessionStore();
export default sessionStore;
